import styled from 'styled-components';

export const UploadContainer = styled.div<{ $dragActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${({ $dragActive, theme }) => ($dragActive ? theme.palette.primary.light : '')};
  padding: 30px 0px;
  border-radius: 8px;
  border: 1px dashed ${({ theme }) => theme.palette.primary.main};
  h1 {
    color: ${({ theme }) => theme.palette.text.primary};
    text-align: center;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.15px;
    font-weight: 400;
  }
  p {
    color: ${({ theme }) => theme.palette.text.secondary};
    text-align: center;
    font-size: 12px;
    line-height: 166%;
    letter-spacing: 0.4px;
    max-width: 450px;
  }
`;

export const UploadButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
  font-weight: 400;
`;
